import { render, staticRenderFns } from "./HakPrintPage1.vue?vue&type=template&id=31735d1d"
import script from "./HakPrintPage1.vue?vue&type=script&lang=js"
export * from "./HakPrintPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports